/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Lazy_Privy_App_Provider_Loading_LabelInputs */

const en_components_lazy_privy_app_provider_loading_label = /** @type {(inputs: Components_Lazy_Privy_App_Provider_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading workspace`)
};

const de_components_lazy_privy_app_provider_loading_label = /** @type {(inputs: Components_Lazy_Privy_App_Provider_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbeitsbereich wird geladen`)
};

const pt_br2_components_lazy_privy_app_provider_loading_label = /** @type {(inputs: Components_Lazy_Privy_App_Provider_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando espaço de trabalho`)
};

const tr_components_lazy_privy_app_provider_loading_label = /** @type {(inputs: Components_Lazy_Privy_App_Provider_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çalışma alanı yükleniyor`)
};

const zh_cn2_components_lazy_privy_app_provider_loading_label = /** @type {(inputs: Components_Lazy_Privy_App_Provider_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载工作区`)
};

const zh_hk2_components_lazy_privy_app_provider_loading_label = /** @type {(inputs: Components_Lazy_Privy_App_Provider_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在載入工作區`)
};

const ko_kr2_components_lazy_privy_app_provider_loading_label = /** @type {(inputs: Components_Lazy_Privy_App_Provider_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`작업 공간 불러오는 중`)
};

const ru_ru2_components_lazy_privy_app_provider_loading_label = /** @type {(inputs: Components_Lazy_Privy_App_Provider_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка рабочей области`)
};

const es_419_components_lazy_privy_app_provider_loading_label = /** @type {(inputs: Components_Lazy_Privy_App_Provider_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando espacio de trabajo`)
};

/**
* | output |
* | --- |
* | "Loading workspace" |
*
* @param {Components_Lazy_Privy_App_Provider_Loading_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_lazy_privy_app_provider_loading_label = /** @type {((inputs?: Components_Lazy_Privy_App_Provider_Loading_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Lazy_Privy_App_Provider_Loading_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_lazy_privy_app_provider_loading_label(inputs)
	if (locale === "de") return de_components_lazy_privy_app_provider_loading_label(inputs)
	if (locale === "pt-BR") return pt_br2_components_lazy_privy_app_provider_loading_label(inputs)
	if (locale === "tr") return tr_components_lazy_privy_app_provider_loading_label(inputs)
	if (locale === "zh-CN") return zh_cn2_components_lazy_privy_app_provider_loading_label(inputs)
	if (locale === "zh-HK") return zh_hk2_components_lazy_privy_app_provider_loading_label(inputs)
	if (locale === "ko-KR") return ko_kr2_components_lazy_privy_app_provider_loading_label(inputs)
	if (locale === "ru-RU") return ru_ru2_components_lazy_privy_app_provider_loading_label(inputs)
	return es_419_components_lazy_privy_app_provider_loading_label(inputs)
});